export default "__VITE_ASSET__DZMQrGeP__"